import { OffsetPoint } from "../../math/OffsetPoint";
import { PickingInfoPoint } from "../../math/PickingInfoPoint";
import { Set } from "immutable";
export const createHexFromCoords = (pigment, { x, y }) => ({ color: pigment, offsetCoords: { x, y } });
export const brushLikeOnClick = ({ highlightLayerContext, viewStateContext }, handler) => (info, event) => {
    const { highlightedHexes } = highlightLayerContext;
    const { pigment } = viewStateContext.editorState;
    const _createHexFromCoords = createHexFromCoords.bind(null, pigment.color);
    if (!info.coordinate)
        return;
    handler(highlightedHexes.map(_createHexFromCoords));
};
export const brushLikeOnDrag = ({ highlightLayerContext, viewStateContext }) => (info) => {
    const { editorState } = viewStateContext;
    const { highlightedHexes, setHighlightedHexes } = highlightLayerContext;
    if (!info.coordinate)
        return;
    if (info.coordinate && editorState.priorDragEvent?.info.coordinate) {
        const lineStart = PickingInfoPoint.toPixelPoint(editorState.priorDragEvent.info.coordinate);
        const lineEnd = PickingInfoPoint.toPixelPoint(info.coordinate);
        return setHighlightedHexes(highlightedHexes.union(OffsetPoint.pointsAlongPixelLine(lineStart, lineEnd, { sampleRate: 2, lineWidth: editorState.brushSize })));
    }
    return info.coordinate && setHighlightedHexes(highlightedHexes.add(PickingInfoPoint.toRoundedOffsetPoint(info.coordinate)));
};
export const brushLikeOnDragEnd = ({ highlightLayerContext, viewStateContext }, handler) => (info) => {
    const { highlightedHexes, setHighlightedHexes } = highlightLayerContext;
    const { pigment } = viewStateContext.editorState;
    const _createHexFromCoords = createHexFromCoords.bind(null, pigment.color);
    const highlighted = Set(info.coordinate ? [PickingInfoPoint.toRoundedOffsetPoint(info.coordinate)] : []);
    setHighlightedHexes(highlighted);
    handler(highlightedHexes.map(_createHexFromCoords));
};
export const brushlikeOnHover = ({ highlightLayerContext, viewStateContext }) => (info, event) => {
    const { editorState, interactionState } = viewStateContext;
    const { setHighlightedHexes } = highlightLayerContext;
    if (interactionState?.isDragging)
        return;
    if (!info.coordinate)
        return setHighlightedHexes(Set());
    if (editorState.priorGestureEvent?.info.coordinate && event.srcEvent.shiftKey) {
        const lineStart = PickingInfoPoint.toPixelPoint(editorState.priorGestureEvent.info.coordinate);
        const lineEnd = PickingInfoPoint.toPixelPoint(info.coordinate);
        return setHighlightedHexes(OffsetPoint.pointsAlongPixelLine(lineStart, lineEnd, { sampleRate: 2, lineWidth: editorState.brushSize }));
    }
    const offsetPoint = PickingInfoPoint.toOffsetPoint(info.coordinate);
    return setHighlightedHexes(OffsetPoint.allPointsWithinRange(offsetPoint, editorState.brushSize - 1));
};
//# sourceMappingURL=_common.js.map